import InvestorDrawer from "./InvestorDrawer"

export default InvestorDrawer
